<template>
    <z-basePage :title="bu_title" :pop="true">
        <div slot="tab-title"  ref="tabTitle">
            <div :class="{active:activeIndex == 0}" @click="chenageTab(0)">职员信息</div>
            <div v-show="tab_judge" :class="{active:activeIndex == 1}" @click="chenageTab(1)">BU信息</div>
            <div v-show="tab_judge" :class="{active:activeIndex == 2}" @click="chenageTab(2)">奖金明细</div>
            <div v-show="tab_judge" :class="{active:activeIndex == 3}" @click="chenageTab(3)">职级明细</div>
            <div v-show="tab_judge" :class="{active:activeIndex == 4}" @click="chenageTab(4)">预算明细</div>
            <div v-show="tab_judge" :class="{active:activeIndex == 5}" @click="chenageTab(5)">罚单明细</div>
        </div>

        <div class="tab-wrap" ref="tabMain">
            <!-- 职员信息 -->
            <div v-show="activeIndex == 0">
                <div class="btns-top">
                    <!--未分组-->
                    <div v-if="bu_type == 10" class="back-btn red" @click="quit()">离职</div>

                    <div v-if="tab_judge" class="back-btn blue" @click="addPerson">添加</div>
                    <div v-if="tab_judge" class="back-btn red" :class="{disabled:deleteIds.length == 0}" @click="removePerson()">移除</div>
                    <div v-if="tab_judge" class="back-btn blue" @click="changeManager(manager_id)">合伙人设置</div>
                </div>

                <div class="back-list">
                    <div class="list-head">
                        <div v-show="bu_type != 20"><el-checkbox v-model="checkall" @change="checkList" :disabled="maxIds.length == 0"></el-checkbox></div>
                        <div>工号</div>
                        <div>姓名</div>
                        <div>职称</div>
                        <div>岗位</div>
                        <div>职级</div>
                        <div>年资</div>
                        <div>生日</div>
                        <div v-if="bu_type != 20">操作</div>
                    </div>
                    <z-scrollDiv>
                        <el-checkbox-group class="list-item" v-model="deleteIds" v-for="item in dataList" :key="item.id">
                            <div v-show="bu_type != 20"><el-checkbox :label="item.id" @change="changeCheck" :disabled="tab_judge && item.bu_identity_type == 1">{{ "" }}</el-checkbox></div>
                            <div>{{ item.user_name }}</div>
                            <div class="overhide"><span class="name" @click="showPerson(item.id)">{{ item.real_name | placeholder }}</span></div>
                            <div class="overhide">{{ item.bu_identity_type == 1?"合伙人":"职员" }}</div>
                            <div class="overhide">{{ item.position_name | placeholder }}</div>
                            <div>{{ `${item.grade}级` }}</div>
                            <div>{{ `${item.work_year}年` }}</div>
                            <div>{{ item.birthday | justDate | placeholder }}</div>
                            <div v-if="bu_type != 20">
                                <span v-if="bu_type == 10" @click="quit(item.id)" class="red">离职</span>
                                <span v-if="tab_judge && item.bu_identity_type == 1" @click="cancelManager(item.id)">取消合伙人</span>
                                <span v-if="tab_judge && item.bu_identity_type == 2" class="red" @click="removePerson(item.id)">移除</span>
                            </div>
                        </el-checkbox-group>
                        <z-noData :list="dataList"></z-noData>
                    </z-scrollDiv>
                </div>

            </div>

            <!-- BU信息 -->
            <info v-show="activeIndex==1 && tab_judge" :index="activeIndex" :buId="buId"></info>

            <!-- 资产明细 -->
            <asset v-show="activeIndex == 2 && tab_judge" :index="activeIndex" :buId="buId"></asset>

            <!-- 职级明细 -->
            <rank v-show="activeIndex == 3 && tab_judge" :index="activeIndex" :buId="buId"></rank>

            <!-- 预算明细 -->
            <budget v-show="activeIndex == 4 && tab_judge" :index="activeIndex" :buId="buId"></budget>

            <!-- 罚单明细 -->
            <ticket v-show="activeIndex == 5 && tab_judge" :index="activeIndex" :buId="buId"></ticket>
        </div>

        <!-- 弹窗 -->
        <!-- 变更合伙人 -->
        <z-windowPop :show="pop.show" :title="`${bu_title}合伙人变更`" :btnshow="pop.btnFlag" :savetext="btnText" @confirm="changeLeader" @cancel="closeLeader" >
            <div class="back-item pop-main">
                <div class="back-title">新BU合伙人</div>
                <div class="back-wrap">
                    <el-select class="top-choose" v-model="pop.userId" @change="changePartner">
                        <el-option-group
                            v-for="(group,key) in pop.userOptions"
                            :key="key"
                            :label="key | trans">
                            <el-option
                                v-for="item in group"
                                :key="item.id"
                                :label="item.real_name"
                                :value="item.id">    
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div>
            </div>
        </z-windowPop>

        <!-- 添加职员 -->
        <z-windowPop :show="pop.user_show" :title="`BU成员选择`" :btnshow="pop.user_ids.length>0" :savetext="`确定`" @confirm="addMembers"  @cancel="closeUser">
            <div class="member-wrap">
                <member :list="pop.user_list" :cancel="pop.cancel_flag" @change="getMemberIds" @cancel="pop.cancel_flag = false"></member>
            </div>
        </z-windowPop>

        <!-- 人员信息弹窗 -->
        <personPop :id="person.id" :show="person.flag"  @infoChange="fresh()" @close="person.flag = false"></personPop>



    </z-basePage>
</template>

<script>
    import info from 'src/views/backEndStage/person/bu/detail-info.vue'
    import asset from 'src/views/backEndStage/person/bu/detail-bonus.vue'
    import rank from 'src/views/backEndStage/person/bu/detail-rank.vue'
    import budget from 'src/views/backEndStage/person/bu/detail-budget.vue'
    import ticket from 'src/views/backEndStage/person/bu/detail-ticket.vue'
    import member from './add-member.vue'


    import personPop from 'src/components/person-detail/person-pop-info.vue'


    export default {
        components:{
            member,
            info,asset,rank,budget,ticket,
            personPop,
        },
        data(){
            return {
                data:{},   //person data
                checkall:false,  //全选
                deleteIds:[],  //删除的id

                pop:{
                    show:false,  //合伙人弹窗判断器
                    userId:"",
                    user_buId:"",  //用户的bu_id  在btnText里更改
                    userOptions:{},  //分组的列表
                    btnFlag:false,  //确认按钮出现

                    user_show:false,   //添加成员 flag
                    user_list:[],  // 最全的成员数据
                    user_ids:[],  // 最终提交的值
                    cancel_flag:false,
                },

                person:{
                    flag:false,
                },
            }
        },
        computed:{
            buId(){  //bu id
                return this.$crypto.decrypt(this.$route.params.buId);
            },
            activeIndex(){  //tab
                return this.$route.query.tab || 0;
            },
            manager_id(){
                let id = "";
                this.dataList.some(item=>{
                    return item.bu_identity_type == 1 && (id = item.id)
                });
                return id;
            },


            bu_title(){  //传进来的BU名称
               return this.data.bu_name;
            },
            bu_type(){  //传进来的bu type
                return this.data.bu_type;
            },
            tab_judge(){   //判断是否显示tab
                return this.bu_type != 10 && this.bu_type != 20;
            },

            dataList(){  //职员列表
                return this.data.list?this.data.list.sort((a,b)=>{
                    return a.bu_identity_type - b.bu_identity_type;
                }):[];
            },
            maxIds(){ //多选  id合集
                return this.dataList.filter(item=>{
                    return item.bu_identity_type != 1;
                }).map(item=>{
                    return item.id;
                });
            },
            // user_options(){  //可选人员列表
            //     return this.pop.user_list.filter(item=>{
            //         let user_ids = this.pop.user_ids || [];
            //         return user_ids.every(id=>id!=item.id);
            //     }).filter(item=>{
            //         return item.real_name.indexOf(this.pop.search_text)!= -1;
            //     });
            // },

            btnText(){  //确认按钮文字
                if(this.pop.userId === ''){
                    return '';
                }
                let obj = this.pop.userOptions;
                for(let key in obj){
                    for(let user of obj[key]){
                        if(user.id == this.pop.userId){
                            this.pop.user_buId = user.bu_id;
                            switch (key) {
                                case 'candidates':
                                    return '任命'
                                case 'employees':
                                    return '提拔'
                                case 'partners':
                                    return '交换'
                            }
                        }

                    }
                }
            },


        },

        filters:{
            trans(str){  // 合伙人分组
                switch (str) {
                    case 'candidates':
                        return '未分组'
                    case 'employees':
                        return '本BU职员'
                    case 'partners':
                        return '合伙人'
                }
            },
        },

        created(){
            this.fresh();
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-bu-info',path:to.path});
			next(res);
        },
        
        methods:{
            fresh(){  //第一次进来拉数据
                let url = `api/admin/bu/user/list`;
                this.checkall = false;
                this.deleteIds = [];
                this.$http.get(url,{
                    params:{
                        bu_id:this.buId
                    }
                }).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },

            // **多选
            checkList(event){ //全选
                this.deleteIds = event.target.checked?[...this.maxIds]:[];
            },
            changeCheck(){  //单选
                this.checkall = this.deleteIds.length === this.maxIds.length;
            },

            // ***按钮功能
            changeManager(id){  //变更合伙人弹窗
                this.pop.show = true;
                let url = "api/admin/bu/partner/candidates"
                this.$http.get(url,{
                    params:{bu_id:this.buId}
                }).then(res=>{
                    if(res.status == 200){
                        res.res_data.employees = res.res_data.employees.filter(item=>item.id != id);
                        if(!this.manager_id){  //无合伙人  无法和其他BU交换合伙人
                            delete res.res_data.partners;
                        }
                        this.pop.userOptions = res.res_data;
                    }
                });
            },
            cancelManager(id){  //取消合伙人
                let url = "api/admin/bu/parter/cancel";
                this.$http.post(url,{
                    user_id:id
                })
                .then(res=>{
                    if(res.status == 200){
                        this.successTip("合伙人取消成功,相应权限已变更");
                        this.fresh();
                    }
                })
            },
            addPerson(){  //添加职员
                let url = `api/admin/candidate_bu/userlist`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.pop.user_list = res.res_data;
                        this.pop.user_show = true;
                    }
                });
            },
            removePerson(id){  //移除人
                this.$func.loading(true);
                let arr = id?[id]:this.deleteIds;
                let url = `api/admin/user/remove`;
                this.$http.post(url,{
                    ids:arr.join(","),
                }).then(res=>{
                    if(res.status == 200){
                        this.fresh();
                        this.successTip("删除成功,相应权限已变更");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
            quit(id){  //离职人
                this.$func.loading(true);
                let arr = id?[id]:this.deleteIds;
                let url = `api/admin/bu/user/leave`;
                this.$http.post(url,{
                    ids:arr.join(","),
                }).then(res=>{
                    if(res.status == 200){
                        this.fresh();
                        this.successTip("离职成功,相应权限已变更");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },

            // ***弹窗
            getMemberIds(arr){
                this.pop.user_ids = arr;
            },
            addMembers(){  //添加职员
                let url =`api/admin/bu/user/add`;
                this.$http.post(url,{
                    bu_id:this.buId,
                    ids:this.pop.user_ids.join(","),
                }).then(res=>{
                    if(res.status == 200){
                        this.fresh();
                        this.closeUser();
                        this.successTip("添加成功,相应权限已变更");
                    }
                })
            },
            closeUser(){
                this.pop.user_show = false;
                this.pop.cancel_flag = true;
                this.pop.user_ids = []; 
            },

            changePartner(id){  //更换合伙人选项
                if(id === ''){
                    this.pop.btnFlag = false;
                }else{
                    this.pop.btnFlag = true;
                }
            },
            changeLeader(){  //保存 变更结果
                this.$func.loading(true);
                let url = `api/admin/bu/partner/reset`;
                this.$http.post(url,{
                    bu_id:this.buId,
                    partner_id:this.pop.userId,
                    partner_buid:this.pop.user_buId,
                }).then(res=>{
                    if(res.status == 200){
                        this.closeLeader();
                        this.fresh();
                        this.successTip('合伙人变更成功');
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip('出错啦');
                    this.$func.loading(false);
                })
            },
            closeLeader(){  //关闭 变更合伙人弹窗
                this.pop.show=false;
                this.pop.userId = '';
            },


            // ***其余
            chenageTab(index){
                this.$router.replace({
                    name:"back-person-bu-detail",
                    query:{
                        tab:index
                    }
                });
            },
            link(id){  //进入职员页面
                // let bu_str =  this.$crypto.encrypt(this.buId);
                let user_str = this.$crypto.encrypt(id);
                this.$router.push({
                    name:'back-person-person-detail',
                    params:{
                        // buId:bu_str,
                        userId:user_str,
                    }
                })
            },
            showPerson(id){
                this.person.id = id;
                this.person.flag = true;
            },

        },

    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";

    .pop-main{
        margin-top: 30px;
        text-align: center;
        >div{
            display:inline-block;
        }
    }

    .tab-wrap{
        height: 100%;
        >div{
            height:100%;
            padding-top:0.1px; 
        }
    }

    .btns-top{
        margin-top: 10px;
    }

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 5%;
            height:100%;
        }
        >div:nth-of-type(2){
            width: 10%;
        }
        >div:nth-of-type(3){
            width: 12%;
            padding-right:3%;
        }
        >div:nth-of-type(4){
            width: 13%;
        }
        >div:nth-of-type(5){
            width: 14%;
            padding-right: 3%;
        }
        >div:nth-of-type(6){
            width: 10%;
        }
        >div:nth-of-type(7){
            width: 10%;
        }
        >div:nth-of-type(8){
            width: 12%;
        }
        >div:last-of-type{
            width: 8%;
            position:relative;
            span{
                color:@blue;
                cursor:pointer;
            }
            .red{
                color:@red;
            }
        }

        .name{
            color:@blue;
            cursor: pointer;
        }

    }

    // 弹窗包裹
    .member-wrap{
        padding:15px 30px;
    }

</style>





// WEBPACK FOOTER //
// page-bu-detail.vue?6191794b